import { render, staticRenderFns } from "./VehiclesIcon.vue?vue&type=template&id=2f9ba050"
import script from "./VehiclesIcon.vue?vue&type=script&lang=ts"
export * from "./VehiclesIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports